namespace TabAurous.Common {

    @Serenity.Decorators.registerEditor()
    export class DiscountOnEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            this.addOption("1", "Amount");
            this.addOption("2", "Percentage");

           
        }
    }
}